import { MeiliSearch } from 'meilisearch'
import config from '@/config'
import { INDEX_UID } from '@/search/facetFields'

let client: MeiliSearch = null

function getIndex() {
  if (!client) {
    client = new MeiliSearch({
      host: config.searchIndexURL(),
      apiKey: config.searchIndexApiKey() || undefined,
    })
  }
  return client.index(INDEX_UID)
}

export default {
  isEnabled(): boolean {
    return !!config.searchIndexURL()
  },

  search(
    query: string,
    filter: string[][],
    facets: string[],
    page: number = null,
    hitsPerPage: number = null,
    sort: string[] = null,
  ) {
    // page/hitsPerPage opt into Meilisearch's "finite pagination" mode, which
    // returns an exact totalHits/totalPages instead of an estimated count -
    // callers that don't paginate keep the old flat limit:100 behavior.
    const pagination = page && hitsPerPage ? { page, hitsPerPage } : { limit: 100 }
    return getIndex().search(query || '', {
      filter, facets, ...pagination, ...(sort ? { sort } : {}),
    })
  },
}
